import '@fpsm/cxy-tokens/tokens.css';

import { type ReactNode } from 'react';
import { type NavV2Response, type OddsFormat, type SiteConfig } from '@cx-web/domain-types';

import { type Repub } from '@cx-modules/constants';

import HeaderDesktop from './components/HeaderDesktop/index';
import HeaderMobile from './components/HeaderMobile/index';
import { type DesktopHeaderTrackingData, type HeaderNavItemTrackingData } from './types';

type HeaderV2Props = {
  betslipSlot?: ReactNode;
  isLoggedIn: boolean;
  // Unleash-backed flag (RENDER_UK_HEADER_STYLE, default OFF) gating the whole UK header restyle.
  // When false (default): legacy OddsFormatDropdownLegacy + legacy StateDropdown + legacy gaps/icons.
  // When true: new UK style (OddsFormatDropdown with icon, new StateDropdown, new gaps/icons).
  isUkStyle?: boolean;
  logoutLabel: string;
  navData: NavV2Response;
  navigationKey?: string;
  oddsFormat: OddsFormat;
  onDesktopHeaderItemClick?: (data: DesktopHeaderTrackingData) => void;
  onLogout: () => void;
  onMenuToggle?: (open: boolean) => void;
  onNavItemClick?: (item: HeaderNavItemTrackingData) => void;
  onOddsFormatChange: (format: OddsFormat) => void;
  onStateChange?: (state: string) => void;
  renderAccountMenu?: (variant: 'desktop' | 'mobile') => ReactNode;
  renderLogo?: ReactNode;
  repub?: Repub;
  repubHomeUrl: string;
  selectedState?: string;
  serverUrl: string;
  siteConfig: SiteConfig;
  stateOptions?: Array<{ code: string; label: string }>;
};

export const HeaderV2 = ({
  betslipSlot,
  isLoggedIn,
  isUkStyle,
  logoutLabel,
  navData,
  navigationKey,
  oddsFormat,
  onDesktopHeaderItemClick,
  onLogout,
  onMenuToggle,
  onNavItemClick,
  onOddsFormatChange,
  onStateChange,
  renderAccountMenu,
  renderLogo,
  repub,
  repubHomeUrl,
  selectedState,
  serverUrl,
  siteConfig,
  stateOptions,
}: HeaderV2Props) => {
  return (
    <>
      <HeaderMobile
        navData={navData}
        oddsFormat={oddsFormat}
        onMenuToggle={onMenuToggle}
        onNavItemClick={onNavItemClick}
        onOddsFormatChange={onOddsFormatChange}
        onStateChange={onStateChange}
        renderAccountMenu={renderAccountMenu}
        renderLogo={renderLogo}
        repubHomeUrl={repubHomeUrl}
        selectedState={selectedState}
        serverUrl={serverUrl}
        siteConfig={siteConfig}
        stateOptions={stateOptions}
      />
      <HeaderDesktop
        betslipSlot={betslipSlot}
        isLoggedIn={isLoggedIn}
        isUkStyle={isUkStyle}
        logoutLabel={logoutLabel}
        navData={navData}
        navigationKey={navigationKey}
        oddsFormat={oddsFormat}
        onDesktopHeaderItemClick={onDesktopHeaderItemClick}
        onLogout={onLogout}
        onOddsFormatChange={onOddsFormatChange}
        onStateChange={onStateChange}
        renderAccountMenu={renderAccountMenu}
        renderLogo={renderLogo}
        repub={repub}
        repubHomeUrl={repubHomeUrl}
        selectedState={selectedState}
        serverUrl={serverUrl}
        siteConfig={siteConfig}
        stateOptions={stateOptions}
      />
    </>
  );
};
